import { createFileRoute } from "@tanstack/react-router";
import { SurveyGate } from "./-components/survey-gate";
import { SurveyResidentList } from "./-components/survey-resident-list";

export const Route = createFileRoute("/survey-portal/")({
  component: SurveyPortalPage,
});

/** A state surveyor's list of the residents the community shared with them, for the day. */
function SurveyPortalPage() {
  return <SurveyGate next="/survey-portal">{() => <SurveyResidentList />}</SurveyGate>;
}
